import {useTheme} from '@mui/material';
import React, {useMemo} from 'react';
import {DayProps, HOVER_TYPE_ENUM} from './Day.types';
import {
	DayContent,
	DayLabel,
	DayTooltip,
	DayTooltipLabel,
	DayWrapper,
	IconPinContainer,
	TodayIndicator,
} from './styles';

const Day: React.FC<DayProps> = ({
	day,
	isDaySelected,
	isToday,
	isDisableColor,
	inative,
	weekendDay,
	setBackgroundInterval,
	isFirstDaySelected,
	isSecondDaySelected,
	isLastDayOfMonth,
	hoverType = HOVER_TYPE_ENUM.CIRCLE,
	tooltipData,
	onClickDay,
	iconPinDay,
	selectIconPinDay,
	colorPinDay,
	onMouseEnter,
	hasFirstDaySelected,
	hasSecondDaySelected,
	showBackgroundIntervalWhenHover,
}) => {
	const {colors} = useTheme();
	const isSunday = weekendDay === 0;
	const isSaturday = weekendDay === 6;
	const isFirstDayOfMonth = day === 1;
	const hasTooltipData = tooltipData ? tooltipData?.length > 0 : false;
	const hasColorPinDay = colorPinDay ? colorPinDay?.length > 0 : false;

	const handleColorDay = useMemo(() => {
		if (inative || isDisableColor) {
			return colors.gray['50Percent'];
		}
		if (isDaySelected) {
			return colors.light.primary.contrast;
		}
		if (colorPinDay) {
			return colorPinDay;
		}

		return colors.light.text.primary;
	}, [inative, isDaySelected, isDisableColor, colorPinDay]);

	return (
		<DayWrapper
			disabled={inative || !day}
			hoverType={hoverType}
			isDaySelected={isDaySelected}
			onClick={onClickDay}
			setBackgroundInterval={setBackgroundInterval}
			hasColorPinDay={hasColorPinDay}
			onMouseEnter={onMouseEnter}
			hasFirstDaySelected={hasFirstDaySelected}
			hasSecondDaySelected={hasSecondDaySelected}
			showBackgroundIntervalWhenHover={showBackgroundIntervalWhenHover}
			type="button">
			{hasTooltipData && !inative ? (
				<DayTooltip isSaturday={isSaturday} isSunday={isSunday}>
					<DayTooltipLabel
						style={{
							fontWeight: 400,
							color: colors.gray['50Percent'],
						}}>
						{tooltipData}
					</DayTooltipLabel>
				</DayTooltip>
			) : null}
			<DayContent
				isDaySelected={isDaySelected}
				setBackgroundInterval={setBackgroundInterval}
				isSunday={isSunday}
				isSaturday={isSaturday}
				isFirstDaySelected={isFirstDaySelected}
				isSecondDaySelected={isSecondDaySelected}
				isFirstDayOfMonth={isFirstDayOfMonth}
				isLastDayOfMonth={isLastDayOfMonth}
				isDisableColor={isDisableColor}
				hasTooltip={hasTooltipData}>
				<DayLabel
					style={{
						fontWeight: colorPinDay ? 700 : 400,
						color: handleColorDay,
					}}>
					{isToday ? <TodayIndicator /> : null}
					{day || ''}
					{iconPinDay ? <IconPinContainer>{iconPinDay}</IconPinContainer> : null}
					{isDaySelected && selectIconPinDay && iconPinDay ? (
						<IconPinContainer>{selectIconPinDay}</IconPinContainer>
					) : null}
				</DayLabel>
			</DayContent>
		</DayWrapper>
	);
};

export {Day};
